import { axios } from "utils";

import { PUBLIC_VERIFICATIONS_URL as endpoint } from "consts";

import { GetVerificationEditingRequestsResponse, PayoutApproval, UpdateEditingRequestRequestBody, VerificationsFarmTasks } from "models";

export const getAllUserVerificationFarmTasks = async (data: { farmId: string; createdInYear?: number }): Promise<VerificationsFarmTasks[]> =>
  axios.get(`${endpoint}/farms/tasks`, { data });

export const updateUserVerificationFarmTask = async (data: { id: string; signal: AbortSignal }) =>
  axios.put(`${endpoint}/farms/tasks/${data.id}`, { data, signal: data.signal });

export const getFarmPayoutApprovals = async (): Promise<PayoutApproval[]> => axios.get(`${endpoint}/farms/payout-approvals`);

// editing requests

export const updateVerificationEditingRequest = async (data: UpdateEditingRequestRequestBody) => axios.put(`${endpoint}/editing-requests/${data.id}`, { data });

export const getVerificationEditingRequests = async (data: { farmId: string }): Promise<GetVerificationEditingRequestsResponse> =>
  axios.get(`${endpoint}/farms/${data.farmId}/editing-requests`, { data });
